import { NavigateNext } from '@mui/icons-material'
import { Breadcrumbs, Stack, Typography } from '@mui/material'
import { LinkRouter } from 'components/breadcrumbs'

export type IBreadcrumbItems = {
  label: string
  url?: string
}

type IBreadcrumbsComponet = {
  itemList: IBreadcrumbItems[]
  currentLabel: string | null
}

export default function BreadcrumbsComponent({ itemList, currentLabel }: IBreadcrumbsComponet) {
  return (
    <Stack
      direction="row"
      justifyContent="space-between"
      alignItems="center"
      spacing={2}
      className="navigation-breadcrump-section"
    >
      <Breadcrumbs separator={<NavigateNext fontSize="small" />}>
        {itemList?.map((item, index) =>
          item.url ? (
            <LinkRouter
              underline="hover"
              color="inherit"
              to={item.url}
              variant="body2DMSans"
              key={item.label + index}
            >
              {item.label}
            </LinkRouter>
          ) : (
            <Typography
              variant="body2DMSans"
              color="text.primary"
            >
              {item.label}
            </Typography>
          )
        )}

        {currentLabel && (
          <Typography
            variant="body2DMSans"
            color="text.primary"
            sx={{ textDecoration: 'underline' }}
          >
            {currentLabel}
          </Typography>
        )}
      </Breadcrumbs>
    </Stack>
  )
}
